import React, { useState, useEffect } from 'react';
import { useLocation } from '../../contexts/LocationContext';
import { useLanguage } from '../../contexts/LanguageContext';
import { CitySelector } from '../CitySelector/CitySelector';
import './LocationIndicator.css';

export const LocationIndicator: React.FC = () => {
  const { currentCity, currentCityData, isLoading } = useLocation();
  const { language, t } = useLanguage();
  const [showCitySelector, setShowCitySelector] = useState(false);
  const [showNotification, setShowNotification] = useState(false);

  // Show auto-detection notification
  useEffect(() => {
    const hasShownNotification = localStorage.getItem('visit_location_notification_shown');
    
    if (!hasShownNotification && currentCity && !isLoading) {
      setShowNotification(true);
      localStorage.setItem('visit_location_notification_shown', 'true');
    }
  }, [currentCity, isLoading]);

  const handleNotificationConfirm = () => {
    setShowNotification(false);
  };

  const handleNotificationChange = () => {
    setShowNotification(false);
    setShowCitySelector(true);
  };

  // Get localized city name
  const getLocalizedCityName = () => {
    if (!currentCityData) return currentCity || t('selectCity', 'citySelector');
    return language === 'en' ? currentCityData.name_en : currentCityData.name_uk;
  };

  if (isLoading) {
    return (
      <button className="location-indicator-button loading" disabled>
        <i className="bi bi-geo-alt"></i>
        {/* <span>Завантаження...</span> */}
        <i className="bi bi-chevron-down" style={{ opacity: 0.5 }}></i>
      </button>
    );
  }

  return (
    <>
      {/* Location Indicator */}
      <button
        onClick={() => setShowCitySelector(true)}
        className="location-indicator-button"
      >
        <i className="bi bi-geo-alt"></i>
        <span>
          {getLocalizedCityName()}
        </span>
        <i className="bi bi-chevron-down"></i>
      </button>

      {/* Auto-detection Notification */}
      {showNotification && (
        <div className="location-notification">
          <div className="notification-content">
            <i className="bi bi-geo-alt-fill notification-icon"></i>
            <div className="notification-text">
              <p className="notification-title">
                Ми визначили ваше місто як <strong>{getLocalizedCityName()}</strong>
              </p>
              <p className="notification-subtitle">
                Це правильно?
              </p>
              <div className="notification-buttons">
                <button
                  onClick={handleNotificationConfirm}
                  className="btn-confirm"
                >
                  Так
                </button>
                <button
                  onClick={handleNotificationChange}
                  className="btn-change"
                >
                  Змінити
                </button>
              </div>
            </div>
            <button
              onClick={() => setShowNotification(false)}
              className="btn-close"
            >
              <i className="bi bi-x"></i>
            </button>
          </div>
        </div>
      )}

      {/* City Selector Modal */}
      <CitySelector
        isOpen={showCitySelector}
        onClose={() => setShowCitySelector(false)}
      />
    </>
  );
};
